module.exports = __webpack_public_path__ + "media/images/checkout/challenger/close-62bbf59e203baf1e4dda22a8f3027ecd.svg";